import { StoreModel } from "../../store/models/StoreModel"

export class ProductBatchStockManagementByStoreModel {
    blockStock: boolean = true
    stores: number[] = []
    storesWrapper: StoreModel[] = []

    constructor(s?: Partial<ProductBatchStockManagementByStoreModel>) {
        Object.assign(this, s)
    }

    isValid():boolean {
        return !!this.storesWrapper?.length
    }

    updateBlockStockStatus(bool: boolean):void {
        this.blockStock = bool
    }

    hasStores():boolean {
        return !!this.storesWrapper?.length;
    }

    clearStores():void {
        this.stores = [];
        this.storesWrapper = [];
    }

    normalize(): ProductBatchStockManagementByStoreModel {
        return new ProductBatchStockManagementByStoreModel({
            blockStock: this.blockStock,
            stores: (this.storesWrapper || []).map((s) => s.id) as number [],
            storesWrapper: this.storesWrapper,
        })
    }
}
